<template>
  <div class="text-center">
    <v-dialog
      v-model="$store.usersStore.state.editPermisosEmpresaUserModal"
      max-width="760"
      scrollable
      persistent
    >
      <v-card
        :loading="loading_user_companies"
        :disabled="loading_user_companies"
        class="pm-card"
        elevation="0"
      >
        <!-- Header -->
        <div class="pm-header">
          <div class="d-flex align-center" style="gap: 12px;">
            <div class="pm-avatar">
              <v-icon color="white" size="20">mdi-office-building-outline</v-icon>
            </div>
            <div>
              <p class="pm-title mb-0">
                Editar permisos: <strong>{{ $store.usersStore.state.selectedUserInfo.name }}</strong>
              </p>
              <p class="pm-subtitle mb-0">Permisos nivel empresa</p>
            </div>
          </div>
          <v-btn icon small @click="closeModal" class="pm-close-btn">
            <v-icon size="18" color="white">mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="pa-0">
          <div class="pm-body">
            <p class="pm-hint">
              Aquí puedes editar los permisos nivel empresa que tendrán los usuarios al ingresar a la plataforma.
            </p>

            <v-form ref="form" v-model="validform">
              <!-- Empresa -->
              <p class="pm-field-label">Empresa</p>
              <div class="d-flex align-center" style="gap: 10px;">
                <v-select
                  v-model="selected_company"
                  :items="user_companies"
                  :loading="loading_user_companies"
                  item-text="name"
                  item-value="id"
                  label="Seleccione empresa"
                  outlined
                  dense
                  hide-details
                  class="pm-select"
                  @change="getCapabilities"
                />
                <v-btn fab x-small depressed color="#2D4B95" dark
                  @click="$store.projectsStore.commit('setNewCompanyModal', true)">
                  <v-icon size="16">mdi-plus</v-icon>
                </v-btn>
              </div>

              <!-- Alert empresa no asignada -->
              <v-alert
                v-if="showAlert"
                dense
                outlined
                type="warning"
                icon="mdi-alert-outline"
                class="mt-3 mb-0"
              >
                <p class="caption mb-0">Este usuario no pertenece a la empresa seleccionada. Debe ser incorporado a la empresa antes de editar sus permisos.</p>
              </v-alert>

              <v-divider class="pm-divider" />

              <!-- Permisos header -->
              <div class="d-flex align-center justify-space-between flex-wrap pm-perms-header">
                <div>
                  <p class="pm-section-main-title mb-0">Permisos</p>
                </div>
                <!-- Seleccionar todo general -->
                <div class="pm-select-all-global" @click="toggleAll">
                  <v-icon size="15" :color="allSelected ? '#2D4B95' : allIndeterminate ? '#2D4B95' : '#bbb'" class="mr-1">
                    {{ allSelected ? 'mdi-checkbox-marked' : allIndeterminate ? 'mdi-minus-box' : 'mdi-checkbox-blank-outline' }}
                  </v-icon>
                  <span :class="['pm-select-all-label', (allSelected || allIndeterminate) ? 'pm-select-all-label--active' : '']">
                    {{ allSelected ? 'Deseleccionar todo' : 'Seleccionar todo' }}
                  </span>
                </div>
              </div>

              <!-- Grid de permisos -->
              <div class="pm-grid">

                <!-- Empresas -->
                <div class="pm-section">
                  <div class="pm-section-header">
                    <p class="pm-section-title mb-0">
                      <v-icon size="13" color="#2D4B95" class="mr-1">mdi-office-building-outline</v-icon>
                      Empresas
                    </p>
                    <span class="pm-select-all-section" @click="toggleSection('empresas')">
                      {{ sectionAllSelected('empresas') ? 'Ninguno' : 'Todos' }}
                    </span>
                  </div>
                  <v-checkbox v-model="permisos.create_company" label="Crear empresas" hide-details dense class="pm-check" />
                  <v-checkbox v-model="permisos.edit_company" label="Editar empresa" hide-details dense class="pm-check" />
                </div>

                <!-- Proyectos -->
                <div class="pm-section">
                  <div class="pm-section-header">
                    <p class="pm-section-title mb-0">
                      <v-icon size="13" color="#2D4B95" class="mr-1">mdi-folder-multiple-outline</v-icon>
                      Proyectos
                    </p>
                    <span class="pm-select-all-section" @click="toggleSection('proyectos')">
                      {{ sectionAllSelected('proyectos') ? 'Ninguno' : 'Todos' }}
                    </span>
                  </div>
                  <v-checkbox v-model="permisos.create_project" label="Crear proyectos" hide-details dense class="pm-check" />
                  <v-checkbox v-model="permisos.edit_project" label="Editar proyectos" hide-details dense class="pm-check" />
                  <v-checkbox v-model="permisos.status_project" label="Modificar estado proyectos" hide-details dense class="pm-check" />
                  <v-checkbox v-model="permisos.config_closing_system" label="Configurar Sistema Cierre" hide-details dense class="pm-check" />
                </div>

                <!-- Usuarios -->
                <div class="pm-section pm-section--full">
                  <div class="pm-section-header">
                    <p class="pm-section-title mb-0">
                      <v-icon size="13" color="#2D4B95" class="mr-1">mdi-account-multiple-outline</v-icon>
                      Usuarios
                    </p>
                    <span class="pm-select-all-section" @click="toggleSection('usuarios')">
                      {{ sectionAllSelected('usuarios') ? 'Ninguno' : 'Todos' }}
                    </span>
                  </div>
                  <div class="pm-files-grid">
                    <v-checkbox v-model="permisos.set_user_projects" label="Editar proyectos de usuarios" hide-details dense class="pm-check" />
                    <v-checkbox v-model="permisos.set_user_permissions" label="Editar permisos de usuarios" hide-details dense class="pm-check" />
                  </div>
                </div>

              </div>
            </v-form>
          </div>
        </v-card-text>

        <!-- Footer -->
        <div class="pm-footer">
          <v-btn rounded outlined depressed class="pm-btn-cancel" @click="closeModal">
            Cancelar
          </v-btn>
          <v-btn rounded depressed dark color="#2D4B95" :loading="loadingData" :disabled="showAlert || !selected_company" @click="setCapabilities">
            Confirmar cambios
          </v-btn>
        </div>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { setCapabilitiesByUserCompany, getCapabilitiesByUserCompany } from "@/helpers/api/user";
import { getCompaniesByUserID } from "@/helpers/api/company";

const DEFAULT_PERMISOS = {
  create_company: false,
  edit_company: false,
  create_project: false,
  edit_project: false,
  status_project: false,
  set_user_projects: false,
  set_user_permissions: false,
}

const SECTION_KEYS = {
  empresas:  ['create_company', 'edit_company'],
  proyectos: ['create_project', 'edit_project', 'status_project'],
  usuarios:  ['set_user_projects', 'set_user_permissions'],
}

const ALL_KEYS = Object.keys(DEFAULT_PERMISOS)

export default {
  name: "EditPermisosEmpresaUserModal",
  data: () => ({
    validform: true,
    user_companies: [],
    projects_id: [],
    selected_company: null,
    loading_user_companies: true,
    loading_project_list: false,
    loadingData: false,
    showAlert: false,
    permisos: { ...DEFAULT_PERMISOS },
  }),
  computed: {
    allSelected() {
      return ALL_KEYS.every(k => this.permisos[k])
    },
    allIndeterminate() {
      return ALL_KEYS.some(k => this.permisos[k]) && !this.allSelected
    },
  },
  mounted() {
    this.getUserCompanies();
  },
  methods: {
    // ── Seleccionar todo general ──────────────────────
    toggleAll() {
      const value = !this.allSelected
      ALL_KEYS.forEach(k => { this.permisos[k] = value })
    },

    // ── Seleccionar todo por sección ──────────────────
    sectionAllSelected(section) {
      return SECTION_KEYS[section].every(k => this.permisos[k])
    },
    toggleSection(section) {
      const value = !this.sectionAllSelected(section)
      SECTION_KEYS[section].forEach(k => { this.permisos[k] = value })
    },

    // ── API ───────────────────────────────────────────
    setJobTypeSelected(select) {
      if (select && select.default_capabilities) {
        this.permisos = { ...DEFAULT_PERMISOS, ...select.default_capabilities };
      }
    },
    async getUserCompanies() {
      this.loading_user_companies = true;
      const companies = await getCompaniesByUserID({
        user_id: this.$store.usersStore.state.selectedUserInfo.id,
        permissions: true,
      });
      if (companies.code == 200) {
        this.user_companies = companies.companies.map((item) => item.company)
        this.selected_company = this.user_companies.length ? this.user_companies[0].id : null
        this.projects_id = companies.companies.map((item) => item.id)
        if (this.selected_company) await this.getCapabilities();
      }
      this.loading_user_companies = false;
    },
    async setCapabilities() {
      if (this.showAlert || !this.selected_company) return
      this.loadingData = true
      const data = {
        user_id: this.$store.usersStore.state.selectedUserInfo.id,
        company_id: this.selected_company,
        capabilities: this.permisos,
      };
      const capabilities = await setCapabilitiesByUserCompany(data);
      if (capabilities.code == 200) {
        this.$store.globalStore.dispatch("addMessage", {
          message: "Se han actualizado los permisos del usuario para la empresa seleccionada.",
          title: "Usuario Actualizado",
          created: new Date(),
          type: "success",
          icon: "mdi-check-circle",
          color: "#3EBFA3",
        });
      }
      this.loadingData = false
    },
    getCapabilities() {
      return new Promise((resolve) => {
        this.showAlert = false
        const data = {
          user_id: this.$store.usersStore.state.selectedUserInfo.id,
          company_id: this.selected_company,
        }
        getCapabilitiesByUserCompany(data)
          .then((capabilities) => {
            if (capabilities.user_company) {
              this.permisos = Object.assign({ ...DEFAULT_PERMISOS }, capabilities.user_company.capabilities)
            } else {
              this.showAlert = true
              this.$store.globalStore.dispatch("addMessage", {
                message: "El usuario no pertenece a la empresa seleccionada. Debe ser incorporado antes de editar sus permisos.",
                title: "Alerta",
                created: new Date(),
                type: "warning",
                icon: "mdi-alert-outline",
                color: "#fb8c00",
              });
            }
            resolve(true)
          })
          .catch(() => {
            this.permisos = { ...DEFAULT_PERMISOS }
            this.showAlert = true
            resolve(false)
          })
      })
    },
    closeModal() {
      this.$store.usersStore.commit("setSelectedUserInfo", null);
      this.$store.usersStore.commit("setEditPermisosEmpresaUserModal", false);
      this.permisos = { ...DEFAULT_PERMISOS };
      this.validform = true;
      this.loadingData = false;
      this.showAlert = false;
    },
  },
};
</script>

<style scoped>
.pm-card {
  border-radius: 12px !important;
  overflow: hidden;
}

/* Header */
.pm-header {
  background-color: #1C3A7A;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pm-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.pm-title { font-size: 14px; font-weight: 400; color: #ffffff; }
.pm-subtitle { font-size: 11px; color: rgba(255, 255, 255, 0.6); }
.pm-close-btn { background: rgba(255, 255, 255, 0.1) !important; }
.pm-close-btn:hover { background: rgba(220, 60, 60, 0.45) !important; }

/* Body */
.pm-body { padding: 20px 24px 8px; }
.pm-hint { font-size: 12px; color: #707070; line-height: 1.6; margin-bottom: 16px; }
.pm-field-label {
  font-size: 11px; font-weight: 500; color: #888;
  text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 6px;
}
.pm-select { flex: 1; }
.pm-divider { margin: 20px 0; }
.pm-perms-header { margin-bottom: 14px; gap: 10px; }
.pm-section-main-title { font-size: 14px; font-weight: 500; color: #2D4B95; }

/* Seleccionar todo global */
.pm-select-all-global {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 5px 11px;
  border-radius: 20px;
  border: 1px solid #C5D0EA;
  transition: background 0.15s;
  user-select: none;
}
.pm-select-all-global:hover { background: #EEF2FB; }
.pm-select-all-label { font-size: 12px; color: #999; white-space: nowrap; }
.pm-select-all-label--active { color: #2D4B95; font-weight: 500; }

/* Grid de secciones */
.pm-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 8px;
}
.pm-section {
  border: 1px solid #E0E6F5;
  border-radius: 10px;
  padding: 10px 14px 12px;
}
.pm-section--full { grid-column: span 2; }

/* Header interno de sección */
.pm-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.pm-section-title {
  font-size: 11px; font-weight: 500; color: #2D4B95;
  text-transform: uppercase; letter-spacing: 0.07em;
  display: flex; align-items: center;
}
.pm-select-all-section {
  font-size: 11px;
  color: #2D4B95;
  cursor: pointer;
  text-decoration: underline;
  text-decoration-color: #C5D0EA;
  text-underline-offset: 2px;
  user-select: none;
  white-space: nowrap;
}
.pm-select-all-section:hover { color: #1C3A7A; text-decoration-color: #1C3A7A; }

/* Checkboxes */
.pm-check { margin-top: 2px !important; }
/deep/ .pm-check .v-label { font-size: 12px !important; color: #444 !important; }
/deep/ .pm-check .v-input--selection-controls__input { margin-right: 4px; }
/deep/ .pm-check.v-input--checkbox .v-icon { font-size: 18px !important; }

/* Grid archivos / usuarios (2 cols dentro de sección full) */
.pm-files-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0 12px;
}

/* Footer */
.pm-footer {
  display: flex; justify-content: flex-end; align-items: center;
  gap: 8px; padding: 14px 24px; border-top: 1px solid #F0F0F0;
}
.pm-btn-cancel { color: #2D4B95 !important; border-color: #C5D0EA !important; }

/* Responsive */
@media (max-width: 540px) {
  .pm-grid { grid-template-columns: 1fr; }
  .pm-section--full { grid-column: span 1; }
}
</style>